import type { Theme } from '@mui/material';

import dayjs from 'dayjs';
import { useSearchParams } from 'react-router';

import { DatePicker } from '@mui/x-date-pickers';
import { Box, Typography, useMediaQuery } from '@mui/material';

export const DateFilter = (props: { filters: any; setFilters: React.Dispatch<any> }) => {
  const { filters, setFilters } = props;
  const downSm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [searchParams] = useSearchParams();

  const handleStartDateChange = (date: any) => {
    setFilters((prev: any) => ({
      ...prev,
      schedule: {
        ...prev.schedule,
        dateInterval: {
          ...prev.schedule.dateInterval,
          from: date,
        },
      },
    }));
  };

  const handleEndDateChange = (date: any) => {
    setFilters((prev: any) => ({
      ...prev,
      schedule: {
        ...prev.schedule,
        dateInterval: {
          ...prev.schedule.dateInterval,
          to: date,
        },
      },
    }));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
        Tarih
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <DatePicker
          label="Başlangıç"
          value={
            dayjs.isDayjs(filters.schedule?.dateInterval?.from)
              ? filters.schedule.dateInterval.from
              : typeof filters.schedule?.dateInterval?.from === 'string'
                ? dayjs(filters.schedule.dateInterval.from)
                : null
          }
          onChange={handleStartDateChange}
          format="DD/MM"
        />
        <DatePicker
          label="Bitiş"
          value={
            dayjs.isDayjs(filters.schedule?.dateInterval?.to)
              ? filters.schedule.dateInterval.to
              : typeof filters.schedule?.dateInterval?.to === 'string'
                ? dayjs(filters.schedule.dateInterval.to)
                : null
          }
          onChange={handleEndDateChange}
          format="DD/MM"
          minDate={
            dayjs.isDayjs(filters.schedule?.dateInterval?.from)
              ? filters.schedule.dateInterval.from
              : typeof filters.schedule?.dateInterval?.from === 'string'
                ? dayjs(filters.schedule.dateInterval.from)
                : undefined
          }
        />
      </Box>
    </Box>
  );
};
